var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.download}},[(_vm.loader)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"24"}}):_c('v-icon',{attrs:{"color":"primary","size":"24"}},[_vm._v(" mdi-download ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }